import { Component, OnInit } from "@angular/core";
import { waitForAsync } from "@angular/core/testing";
import { ActivatedRoute } from "@angular/router";
import { NavController } from "@ionic/angular";
import { AccountService } from "src/app/services/account.service";
import { EnumService } from "src/app/services/enum.service";
import { SharedDataService } from "src/app/services/shared-data.service";
import { UtilService } from "src/app/services/util.service";

@Component({
  selector: "app-okta-response",
  templateUrl: "./okta-response.page.html",
  styleUrls: ["./okta-response.page.scss"],
})
export class OktaResponsePage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private utilService: UtilService,
    private sharedDataService: SharedDataService,
    private navCtrl: NavController
  ) {
    this.route.queryParams.subscribe((param) => {
      if (param.success === 1 || param.success === "1") {
        this.loginSuccess();
      } else if (param.success === 0 || param.success === "0") {
        this.loginError(param.error);
      }
    });
  }

  ngOnInit() {}

  loginSuccess = async () => {
    const email = localStorage.getItem(
      EnumService.LocalStorageKeys.LOGIN_WITH_SSO_FOR_EMAIL
    );
    const loading = await this.utilService.privatePresentLoadingWithOptions();

    if (email) {
      let pathname = "";
      if (
        window.location.href.includes("oktaresponse") ||
        window.location.href.includes("azureresponse")
      ) {
        pathname = window.location.href;
      } else {
        pathname = localStorage.getItem(
          EnumService.LocalStorageKeys.WINDOW_LOCATION
        );
      }

      if (pathname.includes("oktaresponse")) {
        this.accountService.oktaUserSignIn(email).subscribe(
          (user) => {
            if (user) {
              localStorage.setItem(
                EnumService.LocalStorageKeys.LOGIN_WITH_SSO,
                "true"
              );
              this.sharedDataService.isLoginAfterAppOpen = true;
              this.navCtrl.navigateRoot("/tabs/dashboard");
              loading.dismiss();

              if (
                localStorage.getItem(
                  EnumService.LocalStorageKeys.PUSH_PERMISSION_ALLOWED
                ) === "true"
              ) {
                this.sharedDataService.updatePushSettingOnServer(true);
              } else {
                this.sharedDataService.updatePushSettingOnServer(false);
              }
            } else {
              loading.dismiss();
            }
          },
          ({ message }) => {
            this.navCtrl.navigateRoot("checkoktaenable", {
              queryParams: { message },
            });
            loading.dismiss();
          }
        );
      } else if (pathname.includes("azureresponse")) {
        this.accountService.azureUserSignIn(email).subscribe(
          (user) => {
            if (user) {
              localStorage.setItem(
                EnumService.LocalStorageKeys.LOGIN_WITH_SSO,
                "true"
              );
              this.sharedDataService.isLoginAfterAppOpen = true;
              this.navCtrl.navigateRoot("/tabs/dashboard");
              loading.dismiss();

              if (
                localStorage.getItem(
                  EnumService.LocalStorageKeys.PUSH_PERMISSION_ALLOWED
                ) === "true"
              ) {
                this.sharedDataService.updatePushSettingOnServer(true);
              } else {
                this.sharedDataService.updatePushSettingOnServer(false);
              }
            } else {
              loading.dismiss();
            }
          },
          ({ message }) => {
            this.navCtrl.navigateRoot("checkoktaenable", {
              queryParams: { message },
            });
            loading.dismiss();
          }
        );
      }
    } else {
      loading.dismiss();
    }
  };

  loginError = (errorMessage) => {
    this.navCtrl.navigateRoot("checkoktaenable", {
      queryParams: { message: errorMessage },
    });
  };
}
